/**
 * DigitalEvent State
 */

export default {
  themeStyles: {},
  requestCounter: 0,
  useFullPagePreloader: false,
  locks: {}
};
